import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { LanguageId } from '@interfaces';
import { AlignedAccelerator } from '../aligned-accelerators.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<AlignedAccelerator, unknown>[] = [
		buildColumn(util, 'Id', row => row.accProspectAcceleratorId, { header: 'accProspectAcceleratorId' }),
		buildColumn(util, 'Id', row => row.accId, { header: 'accId', hidden: false, width: 80 }),
		buildColumn(util, 'Number', row => row.trimesterId, { header: 'Trimester', width: 80 }),
		buildColumn(util, 'Text', row => row.languageId == LanguageId.Espanol ? 'Spanish' : 'English', { header: 'Language', hidden: true, }),
		buildColumn(util, 'Number', row => row.availableSeatCount, { header: 'Available Seats', width: 90 }),
		buildColumn(util, 'Number', row => row.gravityMiles, { header: 'Gravity Miles', width: 80 }),
		buildColumn(util, 'Text', row => row.meetingLocalDisplayText, { header: 'Session Time (local time)', headerTooltip: 'Time is shown in the time zone of your current location' }),
		buildColumn(util, 'Text', row => row.meetingAcceleratorDisplayText, { header: 'Session Time (accelerator time)', headerTooltip: 'Time is shown in the time zone of the accelerator', hidden: true }),
	];

	return columns;

}